import { useMemo } from 'react'

import type { SpecialCasedSubTemplatedValueSetup } from './types'

export const useSpecialCasedSubTemplatedFieldVariant = (
  data: SpecialCasedSubTemplatedValueSetup,
) =>
  useMemo(
    () =>
      data.field.value?.variants?.find(
        (variant) =>
          variant.subTemplateIdentifier === data.subTemplateIdentifier,
      ),
    [data.field.value?.variants, data.subTemplateIdentifier],
  )
